import React from "react";

const PropertyDamage = ({ size = 50, color }: any) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 384"
      width={size}
      height={size}
    >
      <path
        fill={color}
        d="M366.75,489.28H225c7.5-18.87,14.92-37.77,22.57-56.58a16.63,16.63,0,0,0-.3-14q-17.06-38-33.73-76.22a11.07,11.07,0,0,1-.63-6.36q8.16-37.23,16.68-74.39a17.29,17.29,0,0,0-2-13.21q-22-38.88-43.81-77.91c-5.72-10.19-11.43-20.39-17.22-30.72,10.36-9.55,20.56-18.91,30.72-28.32,7.91-7.31,12.66-7.37,20.68-.29q88.31,78,176.59,156c2.82,2.5,5,5.76,7.41,8.66v5.24c-4.83,10.22-12.29,11.73-20.78,4.22-1.6-1.41-3.26-2.76-5.4-4.57v5.37q0,94.32.09,188.65C375.93,482,373.66,486.89,366.75,489.28Zm-78-181.2c-8.75,0-17.5,0-26.25,0-7.57.05-12.06,4.55-12.08,12.16q-.07,24.33,0,48.65c0,7.62,4.44,12.1,12.11,12.13q26.06.09,52.11,0c7.58,0,12.15-4.56,12.19-12.14q.12-24.31,0-48.65c0-7.55-4.7-12.1-12.21-12.15C306,308,297.36,308.08,288.74,308.08Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M402,275.92c-2.45-2.9-4.59-6.16-7.41-8.66Q306.36,189.2,218,111.28c-8-7.08-12.77-7-20.68.29C187.16,121,177,130.34,166.6,139.89c5.79,10.33,11.5,20.53,17.22,30.72q21.87,39,43.81,77.91a17.29,17.29,0,0,1,2,13.21q-8.55,37.15-16.68,74.39a11.07,11.07,0,0,0,.63,6.36q16.69,38.19,33.73,76.22a16.63,16.63,0,0,1,.3,14c-7.65,18.81-15.07,37.71-22.57,56.58H201c.37-1.18.66-2.38,1.12-3.52,7.45-18.75,14.89-37.51,22.46-56.22a7.7,7.7,0,0,0-.1-6.66c-11.19-25-22.18-50.12-33.38-75.13a19,19,0,0,1-1.25-12.66q8.46-36.78,16.55-73.64a9.08,9.08,0,0,0-.8-5.9q-27-48.53-54.28-96.9c-.52-.92-1.16-1.78-1.86-2.85-.88.75-1.54,1.29-2.17,1.87Q85.67,214.36,24.13,271.09c-2.41,2.22-4.1,5.2-6.13,7.82V105.28H402Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M18,278.91c2-2.62,3.72-5.6,6.13-7.82q61.5-56.79,123.16-113.42c.63-.58,1.29-1.12,2.17-1.87.7,1.07,1.34,1.93,1.86,2.85q27.18,48.42,54.28,96.9a9.08,9.08,0,0,1,.8,5.9q-8.09,36.85-16.55,73.64a19,19,0,0,0,1.25,12.66c11.2,25,22.19,50.11,33.38,75.13a7.7,7.7,0,0,1,.1,6.66c-7.57,18.71-15,37.47-22.46,56.22-.46,1.14-.75,2.34-1.12,3.52H177.75c-.06-1.62-.16-3.24-.16-4.86q0-54.06,0-108.11c0-9.48-4.19-13.6-13.76-13.61-18.24,0-36.48,0-54.72,0-7.53,0-12.13,4.6-12.23,12.1-.07,5,0,10,0,15q0,49.76-.1,99.51H53.25c-6.86-2.42-9.19-7.29-9.17-14.45q.26-93.19.1-186.39v-5.28a81.36,81.36,0,0,1-6.73,6,18.3,18.3,0,0,1-6.54,3.27c-5.7,1.16-9.39-1.43-12.91-8.29Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M96.75,489.28q0-49.75.1-99.51c0-5,0-10,0-15,.1-7.5,4.7-12.08,12.23-12.1,18.24,0,36.48,0,54.72,0,9.57,0,13.76,4.13,13.76,13.61q0,54.06,0,108.11c0,1.62.1,3.24.16,4.86Zm58.1-51.83a4.49,4.49,0,0,0-.77-.46c-6.12-1.86-9.21-5.34-9.38-10.59-.19-5.43,2.51-8.88,8.42-11.4a4.29,4.29,0,0,0,1.87-3.28c.17-7.35.09-14.71.09-22.07v-4.27H119.64v81.18h35.21Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M366.75,489.28c6.91-2.39,9.18-7.32,9.16-14.45q-.23-94.32-.09-188.65v-5.37c2.14,1.81,3.8,3.16,5.4,4.57,8.49,7.51,15.95,6,20.78-4.22V489.28Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M18,284.15c3.52,6.86,7.21,9.45,12.91,8.29a18.3,18.3,0,0,0,6.54-3.27,81.36,81.36,0,0,0,6.73-6v5.28q0,93.2-.1,186.39c0,7.16,2.31,12,9.17,14.45H18Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill="none"
        className="cls-1"
        d="M288.74,308.08c8.62,0,17.24,0,25.86,0,7.51.05,12.17,4.6,12.21,12.15q.12,24.33,0,48.65c0,7.58-4.61,12.11-12.19,12.14q-26.06.09-52.11,0c-7.67,0-12.09-4.51-12.11-12.13q-.06-24.33,0-48.65c0-7.61,4.51-12.11,12.08-12.16C271.24,308.05,280,308.08,288.74,308.08Zm15.58,22.7H273.19v27.83c9.76,0,19.22.05,28.69-.09.82,0,2.32-1.22,2.33-1.9C304.37,348.08,304.32,339.52,304.32,330.78Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill="none"
        d="M154.85,437.45v29.11H119.64V385.38h35.44v4.27c0,7.36.08,14.72-.09,22.07a4.29,4.29,0,0,1-1.87,3.28c-5.91,2.52-8.61,6-8.42,11.4.17,5.25,3.26,8.73,9.38,10.59A4.49,4.49,0,0,1,154.85,437.45Z"
        transform="translate(-18 -105.28)"
      />
      <path
        fill={color}
        d="M304.32,330.78c0,8.74.05,17.3-.11,25.84,0,.68-1.51,1.89-2.33,1.9-9.47.14-18.93.09-28.69.09V330.78Z"
        transform="translate(-18 -105.28)"
      />
    </svg>
  );
};

export default PropertyDamage;
